// extracted by mini-css-extract-plugin
module.exports = {"header":"TransfersV2-module__header--3FBR1","container":"TransfersV2-module__container--2VsBJ","error":"TransfersV2-module__error--3pUi9"};